// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
// External Data
import { QUESTIONS_FLOW_CONTAINER_ID } from 'src/containers/AddSkuPage/QuestionsFlowPage/constants';
// Helpers
import { noop } from 'src/utils/event';
// Components
import { Portal } from 'src/hooks/useCreatePortal';
import Button, { THEMES as BUTTON_THEMES } from 'HTKit/Forms/Button';
import { MobileFooterElement } from 'src/containers/AddSkuPage/QuestionsFlowPage/Parts';
import styles from './styles.scss';

const ProgressButton = ({
  isDisabled = false,
  onClick = noop,
  buttonText = 'Continue',
  continueButtonStyles,
}) => {
  return (
    <>
      <div className={styles.hideMobile}>
        <Button
          theme={BUTTON_THEMES.V2PRIMARY}
          onClick={onClick}
          className={cn(styles.continueButton, continueButtonStyles)}
          disabled={isDisabled}
        >
          {buttonText}
        </Button>
      </div>

      <Portal id={QUESTIONS_FLOW_CONTAINER_ID}>
        <MobileFooterElement buttonText={buttonText} onClick={onClick} disabled={isDisabled} />
      </Portal>
    </>
  );
};

export default ProgressButton;

ProgressButton.propTypes = {
  buttonText: PropTypes.string,
  continueButtonStyles: PropTypes.string,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
};
